import React, { type MouseEventHandler } from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { type RenewType, getRenewTypeTranslation } from "@/models/PatientRenewalInfoModel.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";

export type RenewalDatasource = "monitoring" | "settings" | "header" | "patient-list";

export type PatientRenewalButtonProps = {
  dataSource: RenewalDatasource;
  renewalType: RenewType;
  onClick?: MouseEventHandler;
  className?: string;
};

export const PatientRenewalButton: React.FC<PatientRenewalButtonProps> = ({
  dataSource,
  renewalType,
  onClick,
  className,
}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Button
      id={`renew-tls-button-${dataSource}`}
      data-source={dataSource}
      data-action="care-plan.renewal.renew"
      variant="contained"
      onClick={onClick}
      className={cx(styles.container, className)}
    >
      {t(getRenewTypeTranslation(renewalType))}
    </Button>
  );
};

const makeStyles = () => ({
  container: css({}),
});
